module.exports = __webpack_public_path__ + "static/media/solution-decor3.a69aa74b.png";